import { Navigate, Outlet, type RouteObject } from 'react-router-dom';

import { AdminAuthProvider } from './auth/AdminAuthProvider';
import { AdminLayout } from './pages/AdminLayout';
import { AdminLoginPage } from './pages/AdminLoginPage';
import { AlertRulesPage } from './pages/AlertRulesPage';
import { AlertTemplatesPage } from './pages/AlertTemplatesPage';
import { DiResourcesPage } from './pages/DiResourcesPage';
import { EmailSendersPage } from './pages/EmailSendersPage';
import { LicensePlansPage } from './pages/LicensePlansPage';
import { ModelPricesPage } from './pages/ModelPricesPage';
import { OcrProvidersPage } from './pages/OcrProvidersPage';
import { PlatformDashboardPage } from './pages/PlatformDashboardPage';
import { PlatformProvidersPage } from './pages/PlatformProvidersPage';
import { PreparationCuGovernancePage } from './pages/PreparationCuGovernancePage';
import { PreparationEffectivePolicyPage } from './pages/PreparationEffectivePolicyPage';
import { PromptEditorPage } from './pages/PromptEditorPage';
import { PromptsListPage } from './pages/PromptsListPage';
import { TenantDetailPage } from './pages/TenantDetailPage';
import { TenantsListPage } from './pages/TenantsListPage';

/**
 * Admin routes mounted outside the main app Layout.
 * AdminAuthProvider wraps the entire /admin/* tree so both the login page and
 * the protected pages share the same admin auth context.
 * AdminLayout (pathless child) guards authenticated pages and renders the admin sidebar.
 */
export const adminRoutes: RouteObject[] = [
  {
    path: '/admin',
    element: (
      <AdminAuthProvider>
        <Outlet />
      </AdminAuthProvider>
    ),
    children: [
      { path: 'login', element: <AdminLoginPage /> },
      {
        // Pathless layout route — wraps all authenticated admin pages.
        element: <AdminLayout />,
        children: [
          { index: true, element: <Navigate to="/admin/dashboard" replace /> },
          { path: 'dashboard', element: <PlatformDashboardPage /> },
          { path: 'tenants', element: <TenantsListPage /> },
          { path: 'tenants/:id', element: <TenantDetailPage /> },
          { path: 'plans', element: <LicensePlansPage /> },
          { path: 'platform-providers', element: <PlatformProvidersPage /> },
          { path: 'model-prices', element: <ModelPricesPage /> },
          { path: 'di-resources', element: <DiResourcesPage /> },
          { path: 'ocr-providers', element: <OcrProvidersPage /> },
          { path: 'prompts', element: <PromptsListPage /> },
          { path: 'prompts/:kind', element: <PromptEditorPage /> },
          { path: 'preparation/effective', element: <PreparationEffectivePolicyPage /> },
          { path: 'preparation/cu-governance', element: <PreparationCuGovernancePage /> },
          { path: 'email', element: <Navigate to="/admin/email/rules" replace /> },
          { path: 'email/senders', element: <EmailSendersPage /> },
          { path: 'email/templates', element: <AlertTemplatesPage /> },
          { path: 'email/rules', element: <AlertRulesPage /> },
        ],
      },
    ],
  },
];
